// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false
};

// const msalConfigLocal = {
//   tenant: 'eycloudappdev.onmicrosoft.com',
//   clientId: '07a17b92-13f8-4636-8388-87ccd297a415',
//   authority: 'https://login.microsoftonline.com/',
//   redirectUri: window.location.origin + '/',
//   postLogoutRedirectUri: window.location.origin + '/',
//   apiPath: 'localhost',
//   apiScope: "api://07a17b92-13f8-4636-8388-87ccd297a415/user_impersonation",
// }

const msalConfigDev = {
  tenant: 'eycloudappdev.onmicrosoft.com',
  clientId: '7b702929-f6cf-406f-ad4c-34b3cf83068d',
  authority: 'https://login.microsoftonline.com/',
  redirectUri: window.location.origin + '/',
  postLogoutRedirectUri: window.location.origin + '/',
  apiPath: 'localhost',
  apiScope: "api://7b702929-f6cf-406f-ad4c-34b3cf83068d/user_impersonation",
}

const msalConfigQA = {
  tenant: 'eycloudappdev.onmicrosoft.com',
  clientId: '0572f828-6ab2-40cf-ae53-d4ceb85a567f',
  authority: 'https://login.microsoftonline.com/',
  redirectUri: window.location.origin + '/',
  postLogoutRedirectUri: window.location.origin + '/',
  apiPath: 'caart-qa.ey.com',
  apiScope: "api://0572f828-6ab2-40cf-ae53-d4ceb85a567f/user_impersonation",
}

const msalConfigUAT = {
  tenant: 'eygs.onmicrosoft.com',
  clientId: 'cfbe6f6e-a822-4cc0-917f-92d0ced7370d',
  authority: 'https://login.microsoftonline.com/',
  redirectUri: window.location.origin + '/',
  postLogoutRedirectUri: window.location.origin + '/',
  apiPath: 'caart-uat.ey.com',
  apiScope: "api://cfbe6f6e-a822-4cc0-917f-92d0ced7370d/user_impersonation",
}

const msalConfigProd = {
  tenant: 'eygs.onmicrosoft.com',
  clientId: '8ddd4e7d-08c4-44eb-876a-72e4edec6cee',
  authority: 'https://login.microsoftonline.com/',
  redirectUri: window.location.origin + '/',
  postLogoutRedirectUri: window.location.origin + '/',
  apiPath: 'caart.ey.com',
  apiScope: "api://8ddd4e7d-08c4-44eb-876a-72e4edec6cee/user_impersonation",
}

const msalConfigNewUAT = {
  tenant: '5b973f99-77df-4beb-b27d-aa0c70b8482c',
  clientId: 'cfbe6f6e-a822-4cc0-917f-92d0ced7370d',
  authority: 'https://login.microsoftonline.com/',
  redirectUri: window.location.origin + '/',
  postLogoutRedirectUri: window.location.origin + '/',
  apiPath: 'caart-uat.ey.com',
  apiScope: "api://cfbe6f6e-a822-4cc0-917f-92d0ced7370d/user_impersonation",
}

const msalConfigNewProd = {
  tenant: '5b973f99-77df-4beb-b27d-aa0c70b8482c',
  clientId: '8ddd4e7d-08c4-44eb-876a-72e4edec6cee',
  authority: 'https://login.microsoftonline.com/',
  redirectUri: window.location.origin + '/',
  postLogoutRedirectUri: window.location.origin + '/',
  apiPath: 'caart.ey.com',
  apiScope: "api://8ddd4e7d-08c4-44eb-876a-72e4edec6cee/user_impersonation",
}
export const msalConfigProps = msalConfigNewProd;